// Onde cada etiqueta pode ser escolhida (`applies_to` do Label no backend).
// 'conversation' vale também para contatos. Etiqueta sem o campo (cache antigo)
// conta como 'all'.
export const ESCOPOS_DA_ETIQUETA = ['all', 'conversation', 'kanban'];

const escopoDe = etiqueta => etiqueta?.applies_to || 'all';

export const serveNaConversa = etiqueta => escopoDe(etiqueta) !== 'kanban';

export const serveNoKanban = etiqueta => escopoDe(etiqueta) !== 'conversation';

// Lista do seletor: as etiquetas do lugar + as que já estão aplicadas, para que
// uma etiqueta "do outro lado" que já esteja ali continue podendo ser retirada.
export const etiquetasParaEscolher = (etiquetas, serveAqui, jaAplicadas = []) =>
  (etiquetas || []).filter(
    etiqueta => serveAqui(etiqueta) || jaAplicadas.includes(etiqueta.title)
  );
